module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Store Locator","search":"Search by location","enterPostalCode":"Enter your Zip Code"},"de":{"title":"Filialsuche","search":"Nach Ort suchen"}}')
  delete Component.options._Ctor
}
